/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

import Box from '@mui/material/Box';
import classNames from 'classnames';
import { type FunctionComponent, memo } from 'react';

import type { PageContentsSpacerProps } from './page-contents-spacer.interface';

const PageContentsSpacer: FunctionComponent<PageContentsSpacerProps> = ({
  className,
  spacing,
  ...otherProps
}) => {
  return (
    <Box
      {...otherProps}
      className={classNames(className, 'page-contents-spacer')}
      marginBottom={spacing ?? 3}
      width='100%'
    />
  );
};

const MemoPageContentsSpacer = memo(PageContentsSpacer);

export { MemoPageContentsSpacer as PageContentsSpacer };
